import { cn } from "@/lib/utils";
import { useAlertStore } from "@/store/alerts";
import { Bell } from "lucide-react";
import { Badge } from "../ui/badge";

export const NotificationBell = () => {
  let alertsCounter = useAlertStore((state) => state.alerts.length);
  const clearAlerts = useAlertStore((state) => state.clearAlerts); // Убрать, стоит на время утечки памяти и тестов
  alertsCounter ??= 0;
  const maxCount = 99;

  if (alertsCounter > 120) clearAlerts();

  return (
    <div className="relative flex items-center justify-center p-3">
      <Bell size={16} />
      {alertsCounter > 0 && (
        <Badge
          className={cn(
            "absolute right-0.5 -top-1 w-6 h-6 px-1 flex items-center justify-center text-xs font-bold pointer-events-none",
            alertsCounter <= 10 ? "bg-warning " : "bg-destructive "
          )}
        >
          {alertsCounter > maxCount ? `${maxCount}+` : alertsCounter}
        </Badge>
      )}
    </div>
  );
};
